<template>
  <v-btn
    v-bind="$attrs"
    v-on:click="$emit('click', $event.target.value)"
    :color="btn_color"
    class="button_text--text cstm-v-btn darken-2"
    :title="this.computedBtnText"
  >
    <v-icon v-if="this.btn_icon" small>{{ this.btn_icon }}</v-icon>
    <span v-if="!this.computedIconOnly" :class="'d-sm-inline cstm-v-btn-text' + (this.btn_icon ? '' : 'pa-0')">{{
      this.computedBtnText
    }}</span>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: true,

  props: {
    type: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    text: {
      type: String
    },
    color: {
      type: String
    },
    icon_only: {
      type: Boolean
    },
    icon_only_xs: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      btn_text: "",
      btn_icon: "",
      btn_color: "",
      btn_icon_only: false
    }
  },

  computed: {
    computedBtnText() {
      this.setTextByType(this.type)
      return this.btn_text
    },
    computedIconOnly() {
      if (this.icon_only) return true
      if (this.$vuetify.breakpoint.xsOnly && this.icon_only_xs) return true
    }
  },

  created() {
    this.setTextByType(this.type)
  },

  methods: {
    setTextByType(type) {
      let _text,
        _icon,
        _color = ""

      switch (type) {
        case "new":
          _text = this.$t("global.new")
          _icon = "fas fa-plus"
          _color = "success"
          break
        case "save":
          _text = this.$t("global.save")
          _icon = "fas fa-save"
          _color = "success"
          break
        case "edit":
          _text = this.$t("global.edit")
          _icon = "fas fa-edit"
          _color = "info"
          break
        case "view":
          _text = this.$t("global.view")
          _icon = "fas fa-eye"
          _color = "info"
          break
        case "back":
          _text = this.$t("global.back")
          _icon = "fas fa-arrow-left"
          _color = "info"
          break
        case "download":
          _text = this.$t("global.download")
          _icon = "fas fa-download"
          _color = "info"
          break
        case "role":
          _text = this.$t("roles.title")
          _icon = "recent_actors"
          _color = "info"
          break
        case "permission":
          _text = this.$t("permissions.title")
          _icon = "vpn_key"
          _color = "info"
          break
        case "delete":
          _text = this.$t("global.delete")
          _icon = "fas fa-trash"
          _color = "error"
          break
        case "show_filter":
          _text = this.$t("global.show_filter")
          _icon = "fas fa-filter"
          _color = "info"
          break
        case "filter":
          _text = this.$t("global.filter")
          _icon = "fas fa-filter"
          _color = "info"
          break
        case "pdf":
          _text = this.$t("global.pdf")
          _icon = "fas fa-pdf"
          _color = "info"
          break
        case "reset":
          _text = this.$t("global.reset")
          _icon = "fas fa-sync"
          _color = "info"
          break
        case "cancel":
          _text = this.$t("global.cancel")
          _icon = "fas fa-ban"
          _color = "info"
          break
        case "upload":
          _text = this.$t("global.upload")
          _icon = "fas fa-upload"
          _color = "info"
          break
        case "validate":
          _text = this.$t("global.validate")
          _icon = "fas fa-share-square"
          _color = "success"
          break
        case "default":
          _text = ""
          _icon = ""
          _color = "info"
          break
      }

      this.btn_text = this.text ? this.text : _text
      this.btn_icon = this.icon ? this.icon : this.icon === null ? null : _icon
      this.btn_color = this.color ? this.color : _color
      this.btn_icon_only = this.icon_only
    }
  }
}
</script>